import React, { useState, useEffect } from "react";
import searchIcon from '../icons/searchicon.png';
import closeIcon from '../icons/close.png';
import axios from "axios";
import { baseUrl } from '../shared';
import { getGlobalVariable } from '../shared';

const HelpDetails = ({ helpData = [] }) => {
  const [currentTab, setCurrentTab] = useState("Articles");
  const [overallRating, setOverallRating] = useState(0);
  const [currentArticleRating, setCurrentArticleRating] = useState(null); // Track the selected article for rating section visibility
  const [hoveredStars, setHoveredStars] = useState({}); // Track hovered stars for each rating section
  const [showRating, setShowRating] = useState(true); // Control visibility of rating section
  const [searchTerm, setSearchTerm] = useState("");
  const [showClear, setShowClear] = useState(false);
  const [filteredHelpData, setFilteredHelpData] = useState(helpData);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  // const [initialHelpData, setInitialHelpData] = useState(helpData);

    useEffect(() => {
      const checkGlobalVariable = () => {
        const intValue = parseInt(getGlobalVariable(), 10); // Convert to integer
      };
      checkGlobalVariable(); 
  
      const interval = setInterval(checkGlobalVariable, 100);
  
      return () => clearInterval(interval); // Cleanup interval on unmount
    }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  }; 

  const fetchSearchResults = async (searchTerm) => {
    try {
      const studentkey = sessionStorage.getItem("studentkey");
      const districtID = sessionStorage.getItem("districtID");
      const token = sessionStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        "Content-Type": "application/json", // Optional: Define the content type if needed
      };
  
      if (token != null) {
        const response = await axios.post(
          baseUrl +
          `Student/GetPageDetailsBysearchTitle?studentkey=${studentkey}&districtId=${districtID}&searchKeyWord=${searchTerm}`,
        { headers }
        );
        const data = response.data;
        if (data.data1) {
          const helpList = data.data1.map((item) => ({
            helpTitle: item.Title,
            helpHTML: item.HTML,
            helpPDF: item.PDF,
            helpCategory: item.Category,
            helpID: item.HelpID,
            pageID: item.PageID,
            helpDescription: item.Description,
            rating: item.Rating,
            overallRating: item.OverallRating,
          }));
          console.log(helpList);
          setFilteredHelpData(helpList);
        } else {
          console.log("no help data");
          alert("No data found for the requested Help Page.");
          setFilteredHelpData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching Data:", error);
      setFilteredHelpData([]);
    }
  };

  const handleSearchClick = () => {
    console.log(searchTerm);
    if (searchTerm) {
      setIsSearchClicked(true);
      fetchSearchResults(searchTerm);
      setShowClear(true); // Show the clear icon only after clicking the search icon
    }
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setShowClear(false);
    setIsSearchClicked(false);
    setFilteredHelpData(helpData);
  }; 

  const decodeHTML = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const openCategory = (event, contentId, helpId) => {
    event.preventDefault();
    setCurrentTab(contentId); // Set the current tab to the clicked content

    // If "Articles" tab is clicked again, show the original content and hide the search results
    if (contentId === "Articles") {
      setIsSearchClicked(false); // Reset search result visibility
      setFilteredHelpData(helpData); // Show the original help data
      setShowRating(false); // Hide rating section for Articles
    } else {
      setIsSearchClicked(true); // Ensure search results are visible if not Articles
      setShowRating(true); // Show the rating section for non-Articles tabs
    }

    // Get the overall rating for the selected content
    const contentOverallRating = document.getElementById(`${contentId}contentoverallrating`);
    if (contentOverallRating) {
      setOverallRating(parseFloat(contentOverallRating.textContent) || 0);
    }

    setIsSearchClicked(false);

    // Show content dynamically
    const targetTab = document.getElementById(contentId);
    if (targetTab) {
      targetTab.style.display = "block";
    }

    // Set the selected article's ID for rating visibility
    setCurrentArticleRating(helpId);
  };

  return (
    <div>
      <style>{`
.searchresults{
    text-decoration:none;
    font-size:14px;
}
.searchresults:hover
{ 
    text-decoration:underline; 
}

.HelpTitle {
    font-family: Verdana;
    font-weight: bold;
}

/*Menu css*/
.topnav {
    overflow: hidden;
    background-color: #e9f4ce;
    height: 45px;
    font-family: Verdana;
}

    .topnav a {
        float: left;
        display: block;
        color: black;
        text-align: center;
        padding: 14px 16px;
        text-decoration: none;
        font-size: 12px;
        border: 1px solid #62af48;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }

        .topnav a:hover {
            background-color: #fff;
            color: black;
        }

        .topnav a.active {
            background-color: #fff;
            border-bottom: 3px solid #fff;
            font-weight: bold;
            font-family: Verdana;
            color: black;
        }

.submenu {
    float: left;
    display: block;
    color: black;
    text-align: center;
    padding: 14px 16px;
    font-size: 12px;
    top: 38px;
    position: absolute;
    left: 2px;
    width: 110px;
}

.topnav .search-container {
    float: right;
    margin-right: 45px;
}

.topnav input[type=text] {
    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 12px;
    font-family: Verdana;
    background-color: #e9f4ce;
    background-image: url(${searchIcon}); 
    background-position: 11px 11px;
    background-repeat: no-repeat;
    padding: 11px 11px 11px 40px;
    margin-right: 150px;
    height: 45px;
}

.topnav .search-container button {
    float: right;
    padding: 6px 10px;
    margin-top: 8px;
    margin-right: 16px;
    background: #ddd;
    font-size: 17px;
    border: none;
    cursor: pointer;
}

    .topnav .search-container button:hover {
        background: #ccc;
    }
/*Menu css end*/

/*Help pop up style*/


#mastersearch {
    position: absolute;
    float: right;
    height: 43px;
    width: 43px;
    top: 8px;
    right: 19px;
    background: #aaa;
    color: white;
    text-align: center;
    cursor: pointer;
    border: 2px 2px #e9f4ce;
    border-radius: 0px 4px 4px 0px;
    background-image: url(${searchIcon}); 
    background-size: 16px 16px;
    background-repeat: no-repeat;
    background-position: center;
}

#masterclear {
    position: absolute;
    float: right;
    height: 45px;
    width: 45px;
    top: 8px;
    right: 19px;
    background: #aaa;
    color: white;
    text-align: center;
    cursor: pointer;
    border: 2px 2px #e9f4ce;
    border-radius: 0px 4px 4px 0px;
    background-image: url(${closeIcon}); 
    background-size: 16px 16px;
    background-repeat: no-repeat;
    background-position: center;
}

    #masterclear:hover,
    #masterclear:focus {
        background: #6eb848;
        border-color: white;
        background-image: url(${closeIcon});
        background-size: 20px 20px;
        background-repeat: no-repeat;
        background-position: center;
    }

/**/


/*Help pop up style end*/

    table{
        width:50px;
    }
     table td{
        border:1px solid #331e66;
        padding:5px;
    }

        .HelpTitle {
        vertical-align: middle;
        text-align: center;
        color: white;
        font-size: 20px;
        background-color: #89be51;
    }

    body {
        font-family: Roboto,Roboto Slab,Verdana;
        padding: 0 10px 25px;
        font-size: 14px;
        color: #222;
    }

    body p {
        margin-left: 10px;
        padding-bottom: 15px;
    }

    body a[href] {
        text-decoration: underline
    }

    body table {
        width: 100%;
        border-spacing: 0;
        border-collapse: separate;
    }

    body table caption,
    body table td,
    body table th {
        padding: 15px 7px;
        font: inherit;
    }
    
    body table th {
        font-weight: 400;
        color: #6E6E6E;
        background-position: 100% 100%;
        background-size: 2px 10px;
        background-repeat: no-repeat
    }
    
    body table th:last-child {
        background: 0 0
    }

      `}</style>
      {/* Navigation and Search */}
    <div>
      <div className="topnav">
        <a
          id="tabId0"
          style={{ cursor: "pointer" }}
          onClick={(e) => openCategory(e, "Articles", "0", "0", "0")}
          className={currentTab === "Articles" ? "active" : ""}
        >
          Articles
        </a>

        <div>
        <div className="search-container">
          <input
            id="masterfilterinput"
            type="text"
            placeholder="Master Search"
            name="search"
            autoComplete="off"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>

        {/* Show mastersearch by default */}
        {!showClear && (
          <div
            id="mastersearch"
            onClick={handleSearchClick} // Show clear icon when clicked
          >
          </div>
        )}

        {/* Show masterclear when there is a search term or after clicking search */}
        {showClear && (
          <div
            id="masterclear"
            onClick={handleClearSearch}
          >
          </div>
        )}
      </div>
        </div>
      </div>

      {/* Search Results Section */}
      {isSearchClicked && filteredHelpData.length > 0 && (
        <div id="searchResults" style={{ marginTop: "30px" }}>
          <h2>Search Results</h2>
          {filteredHelpData.map((article) => (
            <div key={article.helpID} style={{ padding: "8px" }}>
              <a
                className="searchresults"
                style={{ color: "#0035ff", textDecoration: "underline" }}
                href="#"
                onClick={(e) => openCategory(e, `Content${article.helpID}`, article.helpID)}
              >
                {article.helpTitle}
              </a>
              <br />
              {article.helpDescription}
            </div>
          ))}
        </div>
      )}

      {/* Content Section */}
      <div id="content" style={{ marginTop: "30px" }}>
        {currentTab === "Articles" && (
          <div id="Articles" className="tabcontent" style={{ display: "block" }}>
            {filteredHelpData && Array.isArray(filteredHelpData) && filteredHelpData
              .filter((article) => article.helpCategory === "Articles")
              .map((article) => (
                <div key={article.helpID} style={{ padding: "8px" }}>
                  <a
                    className={`searchresults ${currentTab === `Content${article.helpID}` ? "active" : ""}`}
                    style={{
                      color: "#0035ff",
                      textDecoration: "underline",
                    }}
                    href="#"
                    onClick={(e) =>
                      openCategory(e, `Content${article.helpID}`, article.helpID)
                    }
                  >
                    {article.helpTitle}
                  </a>
                  <br />
                  {article.helpDescription}
                </div>
              ))}
          </div>
        )}

        {helpData.map((article) => (
          <div
            key={article.helpID}
            id={`Content${article.helpID}`}
            className="tabcontent"
            style={{
              display: currentTab === `Content${article.helpID}` ? "block" : "none",
            }}
          >
            <label
              id={`Content${article.helpID}contentrating`}
              style={{ display: "none" }}
            >
              {article.helpID}
            </label>
            <label
              id={`Content${article.helpID}contentoverallrating`}
              style={{ display: "none" }}
            >
              {article.overallRating || 0}
            </label>
            <label
              id={`Content${article.helpID}ratingvalue`}
              style={{ display: "none" }}
            >
              {article.rating || 0}
            </label>
            <div
      dangerouslySetInnerHTML={{
        __html: decodeHTML(article.helpHTML),
      }}
      style={{ marginTop: "10px" }}
    ></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HelpDetails;